<script setup lang="ts">
import type { TwoFactor } from '../types';
import TwoFactorAuthLogin from '@/components/domain/two-factor-auth/Login.vue';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<{
    twoFactor: TwoFactor
}>();
</script>

<template>
    <TwoFactorAuthLogin
        class="two-factor"
        :action-path="props.twoFactor.actionPath"
        :logout-path="props.twoFactor.logoutPath"
        :error="props.twoFactor.error"
        :auth-code-parameter-name="props.twoFactor.authCodeParameterName"
        :trusted-parameter-name="props.twoFactor.trustedParameterName"
        :csrf-token="props.twoFactor.csrfToken"
        :display-trusted-option="props.twoFactor.displayTrustedOption"
        :was-backup-code-attempt="props.twoFactor.wasBackupCodeAttempt"
    />
</template>

<style scoped>
@reference '@/assets/styles/config.css';
</style>
